import {AxiosProgressEvent} from 'axios';

import {
	PostRefundUploadFile,
	PostRefundUploadFileParams,
	PostRefundUploadFileResponse,
} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundPostUploadFile implements PostRefundUploadFile {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRefundUploadFileResponse>,
		private readonly onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
	) {}

	async post(params: PostRefundUploadFileParams): Promise<PostRefundUploadFileResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			responseType: 'json',
			onUploadProgress: this.onUploadProgress,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
